(()=>{
 const linkPrivacy=()=>document.querySelectorAll('.shopify-pc__banner__body a[href*="/policies/privacy-policy"], .shopify-pc__prefs__dialog a[href*="/policies/privacy-policy"]').forEach(link=>{link.href='/pages/datenschutz'});
 linkPrivacy();new MutationObserver(linkPrivacy).observe(document.body,{childList:true,subtree:true});
 let loading;
 const loadBanner=()=>{
  if(window.privacyBanner?.showPreferences)return Promise.resolve(window.privacyBanner);
  if(!loading)loading=new Promise((resolve,reject)=>{
   const script=document.createElement('script');script.src='https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';script.async=true;
   script.onload=()=>window.privacyBanner?.showPreferences?resolve(window.privacyBanner):reject(new Error('unavailable'));
   script.onerror=()=>reject(new Error('unavailable'));document.head.append(script);
  }).catch(error=>{loading=null;throw error});
  return loading;
 };
 document.addEventListener('click',async event=>{
  const button=event.target.closest('[data-cookie-preferences]');if(!button)return;
  event.preventDefault();if(button.disabled)return;button.disabled=true;button.setAttribute('aria-busy','true');
  let error=button.parentElement.querySelector('[data-privacy-error]');if(error)error.remove();
  try{const banner=await loadBanner();await banner.showPreferences()}
  catch{error=document.createElement('p');error.dataset.privacyError='';error.setAttribute('role','status');error.style.fontSize='13px';error.textContent=document.body.dataset.privacyErrorMessage;button.parentElement.append(error)}
  finally{button.disabled=false;button.removeAttribute('aria-busy')}
 });
})();
